import {
    Box,
    Card,
    CardContent,
    Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import DateFormat from '../../utils/DateFormat';

function UpcomingClosingDaysCard({ sx, date, closingDays, flexTimeAccount, workHoursClosingDays }) {
    const { t } = useTranslation();

    return (
        <Card sx={sx}>
            <CardContent>
                <Typography sx={{ fontWeight: 'bold', mb: 2 }}>{date.toLocaleDateString(i18n.language, { month: 'long', year: 'numeric' })}</Typography>
                <Typography>
                    {
                        flexTimeAccount - workHoursClosingDays >= 0 &&
                        <>
                            {
                                // manual translation because of complexity
                                i18n.language === 'de' ?
                                    <Typography>
                                        Im {date.toLocaleDateString(i18n.language, { month: 'long' })} {closingDays > 1 ? 'stehen ' : 'steht '}
                                        {closingDays} {closingDays > 1 ? 'Brückentage' : 'Brückentag'} an.
                                        Falls du hierfür Zeitausgleich planst, wird das Guthaben auf deinem Gleitzeitkonto entsprechend reduziert:
                                    </Typography>
                                    :
                                    <Typography>
                                        In {date.toLocaleDateString(i18n.language, { month: 'long', year: 'numeric' })} {closingDays > 1 ? 'are ' : 'is '}
                                        {closingDays} closing {closingDays > 1 ? 'days' : 'day'} remaining.
                                        If you intend to use your working time account credit for compensation,
                                        your account will be reduced by your contract work load for {closingDays > 1 ? 'these days' : 'this day'}:
                                    </Typography>
                            }
                        </>
                    }
                    {
                        flexTimeAccount - workHoursClosingDays < 0 &&
                        <>
                            {
                                // manual translation because of complexity
                                i18n.language === 'de' ?
                                    <Typography>
                                        Im {date.toLocaleDateString(i18n.language, { month: 'long', year: 'numeric' })} {closingDays > 1 ? 'stehen ' : 'steht '}
                                        {closingDays} {closingDays > 1 ? 'Brückentage' : 'Brückentag'} an.
                                        Falls du hierfür Zeitausgleich planst, fehlt dir noch Guthaben auf deinem Gleitzeitkonto:
                                    </Typography>
                                    :
                                    <Typography>
                                        In {date.toLocaleDateString(i18n.language, { month: 'long', year: 'numeric' })} {closingDays > 1 ? 'are ' : 'is '}
                                        {closingDays} closing {closingDays > 1 ? 'days' : 'day'} remaining.
                                        If you intend to use your work account credit for working time compensation,
                                        you don't have enough flexitime:
                                    </Typography>
                            }
                        </>
                    }
                </Typography>
                <Box sx={{ display: 'flex', mt: 3, justifyContent: 'space-between' }}>
                    <Typography>{t('aktuellesGuthaben', { ns: 'dashboardPage', defaultValue: 'Aktuelles Guthaben' })}</Typography>
                    <Typography sx={{ color: flexTimeAccount >= 0 ? 'green' : 'red' }}>
                        {flexTimeAccount > 0 ? '+' : ''}
                        {DateFormat.formatDuration(flexTimeAccount)}
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography>{t('benötigteGleitzeit', { ns: 'dashboardPage', defaultValue: 'Für Zeitausgleich benötigte Gleitzeit' })}</Typography>
                    <Typography>-{DateFormat.formatDuration(workHoursClosingDays)}</Typography>
                </Box>
                <hr />
                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    {
                        flexTimeAccount - workHoursClosingDays >= 0 &&
                        <Typography sx={{ fontWeight: ' bold' }}>
                            {t('verbleibendeGleitzeit', { ns: 'dashboardPage', defaultValue: 'Verbleibendes Gleitzeitguthaben' })}
                        </Typography>
                    }
                    {
                        flexTimeAccount - workHoursClosingDays < 0 &&
                        <Typography sx={{ fontWeight: ' bold' }}>
                            {t('nochAufzubauendeGleitzeit', { ns: 'dashboardPage', defaultValue: 'Noch aufzubauendes Gleitzeitguthaben' })}
                        </Typography>
                    }
                    <Typography sx={{ color: flexTimeAccount - workHoursClosingDays >= 0 ? 'green' : 'red' }}>
                        {flexTimeAccount - workHoursClosingDays > 0 ? '+' : ''}
                        {DateFormat.formatDuration(Math.abs(flexTimeAccount - workHoursClosingDays))}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
};

export default UpcomingClosingDaysCard
